import React from 'react';
import { observer } from 'mobx-react';
import { StringStore } from 'ui/base/input/store';
import { InputChangeEvent, InputProps } from 'ui/base/types';

export type EmailInputProps = Omit<InputProps, 'type' | 'value' | 'onChange'> & {
  store: StringStore;
};

export const EmailInput = observer(({ store, ...props }: EmailInputProps) => {
  const onChange = React.useCallback((event: InputChangeEvent) => {
    store.setValue(event.target.value);
  }, [store]);

  return <input type='email' value={store.value} onChange={onChange} {...props}/>;
});
